import { render, staticRenderFns } from "./ImageField.vue?vue&type=template&id=c51c20da&scoped=true"
import script from "./ImageField.vue?vue&type=script&lang=js"
export * from "./ImageField.vue?vue&type=script&lang=js"
import style0 from "./ImageField.vue?vue&type=style&index=0&id=c51c20da&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51c20da",
  null
  
)

export default component.exports